/* Decorative SVG; title intentionally omitted because this conflicts with tooltips */
export function UnpinIcon() {
  return (
    <i className="icon d-flex">
      <svg className="icon" width="24" height="24" viewBox="0 0 24 24">
        <path d="M19.4,19.3L4.8,4.7L3.5,6l4.2,4.2C7.3,11.3,6.2,12,5,12v2h6v7l1,1l1-1v-5.6l5.2,5.2L19.4,19.3z M6.4,3.8C6.6,3.9,6.8,4,7,4h1v1.4l8.6,8.6H19v-2c-1.7,0-3-1.3-3-3V4h1c0.5,0,1-0.5,1-1s-0.5-1-1-1H7 C6.5,2,6,2.5,6,3c0,0.2,0.1,0.4,0.2,0.6L6.4,3.8z" />
      </svg>
    </i>
  );
}
